import {
	ADD_TEMPLATE_SUCCESS,
	GET_SINGLE_TEMPLATE_SUCCESS,
	GET_TEMPLATES_SUCCESS,
	RESTORE_SINGLE_TEMPLATE_SUCCESS,
	SOFT_DELETE_SINGLE_TEMPLATE_SUCCESS,
	UPDATE_TEMPLATE_SUCCESS,
} from "../actions/template/template.actionType";
import globalState from "../state";

const requestRegex = /_REQUEST/;
const errorRegex = /_FAILURE/;
const successRegex = /_SUCCESS/;

const initialState = {
	errorMessage: "",
	isLoading: false,
	templates: [],
	template: {},
	...globalState,
};

const TemplateReducer = (state = initialState, action) => {
	const isRequest = requestRegex.test(action.type);
	const isError = errorRegex.test(action.type);
	const isSuccess = successRegex.test(action.type);

	if (isRequest) {
		return { ...state, isLoading: true, errorMessage: "" };
	}
	if (isError) {
		return { ...state, isLoading: false, errorMessage: action.message };
	}
	if (isSuccess) {
		state = { ...state, isLoading: false, errorMessage: "" };
	}

	switch (action.type) {
		case GET_TEMPLATES_SUCCESS:
			return { ...state, templates: action.data };

		case GET_SINGLE_TEMPLATE_SUCCESS:
			return { ...state, template: action.data };

		case SOFT_DELETE_SINGLE_TEMPLATE_SUCCESS:
			let softDeletedTemplateId = action.data;
			let afterSoftDeletedData = state.templates.filter(
				(data) => data.id.toString() !== softDeletedTemplateId.toString()
			);
			return { ...state, templates: afterSoftDeletedData };

		case ADD_TEMPLATE_SUCCESS:
			return { ...state };

		case RESTORE_SINGLE_TEMPLATE_SUCCESS:
			return { ...state };

		case UPDATE_TEMPLATE_SUCCESS:
			return { ...state };

		default:
			return state;
	}
};

export default TemplateReducer;
